// extracted by mini-css-extract-plugin
module.exports = {"textContainer":"TextBlock_textContainer__ffbIX","v1":"TextBlock_v1__8kwks","fullWidth":"TextBlock_fullWidth__uk2M2","v2":"TextBlock_v2__zGysi"};